var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-7 -7 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -2.25 11.61 C 0.774 -6.534 24.966 -6.534 27.99 11.61 L 12.87 29.754 L -2.25 11.61 L 0.774 11.61 L 0.774 11.61 L 12.87 26.73 L 24.966 11.61 L 27.99 11.61 L 24.966 11.61 C 21.942 8.586 21.942 8.586 18.918 11.61 L 15.894 11.61 C 12.87 8.586 12.87 8.586 9.846 11.61 L 6.822 11.61 C 3.798 8.586 3.798 8.586 0.774 11.61 L 12.87 26.73 L 6.822 11.61 L 9.846 11.61 L 12.87 26.73 L 15.894 11.61 L 18.918 11.61 L 12.87 26.73",
    fill: "#0e6890"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.12044234a97ccb075eb3da50641d487a.svg";
export { ForwardRef as ReactComponent };